import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { tap, timeout } from 'rxjs/operators';
import { environment } from "../../environments/environment";
import { BBResponseContainer } from '../carrier/response-container';
import { BoxDeliveryDTO } from '../models/boxDelivery';
import { SearchDelivery } from '../models/searchDelivery';

@Injectable()
export class ApgDeliveryService {

  readonly timeoutForExcelSave = 30000;

  constructor(private http: HttpClient) {
  }


  getBoxDelivery(searchDelivery: SearchDelivery): Observable<any> {
    let url = environment.BB_MA_DELIVERY_API + 'ma/delivery/list/search';
    return this.http.post<any>(url, searchDelivery).pipe(timeout(environment.defaultTimeout), tap(event => { }, error => {
      error.url = url;
    }));

  }

  validateBox(boxId: string, lab: string): Observable<BBResponseContainer> {
    let url = environment.BB_MA_DELIVERY_API + 'ma/delivery/list/validate';
    let requestParam = new HttpParams().set('boxId', boxId).set('lab', lab);
    const options = url ? { params: requestParam } : {};
    return this.http.get<BBResponseContainer>(url, options).pipe(timeout(environment.defaultTimeout), tap(event => { }, error => {
      error.url = url;
    }));
  }

  performBoxReception(boxDeliveryList: BoxDeliveryDTO[]): Observable<BBResponseContainer> {
    let url = environment.BB_MA_DELIVERY_API + 'ma/delivery/list/receive';
    return this.http.put<BBResponseContainer>(url, boxDeliveryList).pipe(timeout(environment.defaultTimeout), tap(event => { }, error => {
      error.url = url;
    }));
  }

  validateBoxId(lab: string, boxId: string, project: string): Observable<BBResponseContainer> {
    let url = environment.BB_MA_DELIVERY_API + 'ma/delivery/list/validate/boxId';
    let requestParam = new HttpParams().set('labId', lab).set('scannedBoxId', boxId).set('projectId', project);
    const options = url ? { params: requestParam } : {};
    return this.http.get<BBResponseContainer>(url, options).pipe(timeout(environment.defaultTimeout), tap(event => { }, error => {
      error.url = url;
    }));
  }
  updateBoxIdStatus(searchDelivery : SearchDelivery) {
    let url = environment.BB_MA_DELIVERY_API + 'ma/delivery/list/statusUpdate';
    return this.http.put<BBResponseContainer>(url, searchDelivery).pipe(timeout(environment.defaultTimeout), tap(event => { }, error => {
      error.url = url;
    }));
  }

}
